import React, { useEffect, useMemo, useState } from "react";
import { Dispatch } from "redux";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Navigate,
  Outlet,
} from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";

import { getCurrentUserDetails } from "./app/common/routines/user-operations";
import { routes } from "./app/constants/routes";
import { CONTRACT_MANAGEMENT_TYPE, MODULES } from "./app/utils/constants";
import AppRoute from "./app-route";
import MainLayout from "./app/layouts/mainLayout";

import HomePage from "./app/features/home-page/homepage-new";
import LoginPage from "./app/features/login-page/login-page";
import AuthCallback from "./app/features/login-page/auth-callback";
import NotFound from "./app/features/notfound-page/notfouund";

import ServicesPage from "./app/features/services-page/services-page";
import ListingPage from "./app/features/listing-page/listing-page";
import DetailsPage from "./app/features/details-page/details-page";
import ReviewsPage from "./app/features/details-page/components/ReviewsPage";
import ContactUsPageNew from "./app/features/contact-us-page/contact-us-page-new";
import PreneedPlannersPage from "./app/features/preneed-planners/preneed-planners";
import PreneedPlannersDetailsPage from "./app/features/preneed-planners-details-page/preneed-planners-details-page";
import OrderSummaryPage from "./app/features/order-summary-page/order-summary-page";
import CartPage from "./app/features/cart-page/cart-page";
import PaymentStatusPage from "./app/features/payment-status-page/payment-status-page";
import BecomeProvider from "./app/features/become-provider-page/become-provider";
import PartnerRegistrationForm from "./app/features/become-provider-page/components/partner-registration-form/partner-registration-form";
import PaymentPage from "./app/features/payment-page/payment-page";
import UserProfilePage from "./app/features/user-profile/user-profile";

import AdminSection from "./app/features/admin-section";
import ProviderRequestLists from "./app/features/admin-section/features/provider-management/provider-requests/provider-requests-list";
import ViewProviderRequestDetails from "./app/features/admin-section/features/provider-management/provider-requests/view-provider-request-details";
import ProviderProfilesList from "./app/features/admin-section/features/provider-management/provider-profiles/provider-profiles-list";
import ViewProviderProfileDetails from "./app/features/admin-section/features/provider-management/provider-profiles/view-provider-profile-details";
import PlannerProfilesList from "./app/features/admin-section/features/planner-management/planner-profiles/planner-profiles-list";
import PlannerRequestsList from "./app/features/admin-section/features/planner-management/planner-requests/planner-requests-list";
import ServiceList from "./app/features/admin-section/features/service-management/services-list/services-list";
import ProfileManagement from "./app/features/admin-section/features/profile-management/profile-management";
import UserManagement from "./app/features/admin-section/features/user-management/user-management";
import BulkUploadOperations from "./app/features/admin-section/features/bulk-upload-operations/bulk-upload-operations";
import ProviderServicesList from "./app/features/provider-section/service-management/services-list/provider-services-list";
import TermsOfServicePage from "./app/common/components/terms-of-service/terms-of-service";
import TermsOfServicePublic from "./app/common/components/terms-of-service/terms-of-service-public";
import CommunicationManagement from "./app/features/admin-section/features/communication-management/communication-management";
import ViewTicketDetails from "./app/features/admin-section/features/communication-management/view-ticket-details";

import ProtectedAdminRoute from "./app/protected-admin-route";
import ProtectedProviderRoute from "./app/protected-provider-route";
import ProviderSection from "./app/features/provider-section";
import Dashboard from "./app/features/provider-section/provider-dashboard/dashboard";
import ProfileManagementTabs from "./app/features/provider-section/profile-management/profile-management-tabs";

import ForgotPasswordPage from "./app/features/provider-section/forgot-password/forgot-password.page";
import ResetPasswordPage from "./app/features/provider-section/forgot-password/reset-password-page";
import OrderHistoryPage from "./app/features/order-history-page/order-history-page";
import OrderDetailsPage from "./app/features/order-details-page/order-details-page";
import BookingRequests from "./app/features/provider-section/booking-and-appointment/booking-requests";
import ProviderProfilePage from "./app/features/provider-section/provider-profile/ProviderProfile";
import PaymentsBilling from "./app/features/provider-section/payments-and-billing/payments-billing-list";
import ViewPaymentDetails from "./app/features/provider-section/payments-and-billing/view-payment-details";
import ContractManagement from "./app/features/provider-section/contract-management/contract-management";
import Communication from "./app/features/provider-section/communication/communication";
import ProviderViewTicketDetails from "./app/features/provider-section/communication/view-ticket-details";

//  PRENEED (added)
import PreneedSection from "./app/features/preneed-section";
import ProtectedPreneedRoute from "./app/protected-preneed-route"; //  create similar to provider route
import PreneedDashboard from "./app/features/preneed-section/preneed-dashboard/dashboard"; //  adjust path as per your project
import PreneedProfileManagementTabs from "./app/features/preneed-section/profile-management/profile-management-tabs";
// import PreneedProfilePage from "./app/features/preneed-section/preneed-profile/PreneedProfile"; // optional
import PreneedForgotPasswordPage from "./app/features/preneed-section/forgot-password/forgot-password.page";
import PreneedResetPasswordPage from "./app/features/preneed-section/forgot-password/reset-password-page";
import PreneedPaymentBillingList from "./app/features/preneed-section/payments-and-billing/payments-billing-list";
import PreneedViewPaymentDetails from "./app/features/preneed-section/payments-and-billing/view-payment-details";
import PreneedCommunication from "./app/features/preneed-section/communication/communication";
import PreneedViewTicketDetails from "./app/features/preneed-section/communication/view-ticket-details";
import PreneedProfilePage from "./app/features/preneed-section/preneed-profile/PreneedProfile";
import CreatePackage from "./app/features/preneed-section/service-package/create-services";
import PreneedBookingRequests from "./app/features/preneed-section/preneed-booking-and-appointment/preneed-booking-requests";
import PaymentAndBilling from "./app/features/admin-section/features/payments-and-billing/payments-billing-list"
import ViewOrder from "./app/features/admin-section/features/payments-and-billing/view-payment-details"
import Leads from "./app/features/provider-section/booking-and-appointment/leads-section/leads";
import LeadDetails from "./app/features/provider-section/booking-and-appointment/leads-section/lead-details";
import ProviderLeadDetailsWrapper from "./app/features/provider-section/booking-and-appointment/leads-section/provider-lead-details-wrapper";
import PreneedLeadDetailsWrapper from "./app/features/preneed-section/preneed-booking-and-appointment/preneed-lead-details-wrapper";
import PreneedLeads from "./app/features/preneed-section/preneed-booking-and-appointment/preneed-leads";
import ComingSoon from "./app/features/coming-soon/ComingSoon";

interface RootState {
  session: {
    isLoggedIn: boolean;
    userDetails: Record<string, unknown>;
    isAdminLoggedIn: boolean;
    superAdminDetails: Record<string, unknown>;
    isProviderLoggedIn: boolean;
    providerDetails: Record<string, unknown>;

    //  PRENEED (added)
    isPreNeedLoggedIn: boolean;
    preNeedDetails: Record<string, unknown>;
  };
  appearance: {
    appDataLoading: boolean;
    listView: boolean;
  };
}

interface AppProps {
  isLoggedIn: boolean;
  loggedIn?: boolean;
  userDetails: Record<string, unknown>;
  superAdminDetails: Record<string, unknown>;
  appDataLoading: boolean;

  isAdminLoggedIn: boolean;
  isProviderLoggedIn: boolean;
  providerDetails: Record<string, unknown>;

  //  PRENEED (added)
  isPreNeedLoggedIn: boolean;
  preNeedDetails: Record<string, unknown>;

  setLoggedIn: (
    value: boolean,
    userDetails: Record<string, unknown>,
    superAdminDetails: Record<string, unknown>,
    providerDetails: Record<string, unknown>,
    preNeedDetails: Record<string, unknown>, //  added
    isAdminLogin?: boolean,
    isProviderLogin?: boolean,
    isPreNeedLogin?: boolean,
  ) => void;
}

const mstp = (state: RootState) => ({
  isLoggedIn: state.session.isLoggedIn,
  appDataLoading: state.appearance.appDataLoading,
  userDetails: state.session.userDetails,
  listView: state.appearance.listView,
  isAdminLoggedIn: state.session.isAdminLoggedIn,
  superAdminDetails: state.session.superAdminDetails,
  isProviderLoggedIn: state.session.isProviderLoggedIn,
  providerDetails: state.session.providerDetails,

  //  PRENEED (added)
  isPreNeedLoggedIn: state.session.isPreNeedLoggedIn,
  preNeedDetails: state.session.preNeedDetails,
});

const mdtp = (dispatch: Dispatch) => ({
  setLoggedIn: (
    value: boolean,
    userDetails: Record<string, unknown>,
    superAdminDetails: Record<string, unknown>,
    providerDetails: Record<string, unknown>,
    preNeedDetails: Record<string, unknown>, //  added
    isAdminLogin?: boolean,
    isProviderLogin?: boolean,
    isPreNeedLogin?: boolean,
  ) => {
    dispatch({
      type: "SESSION:SET_IS_LOGGED_IN",
      payload: {
        value,
        userDetails,
        superAdminDetails,
        providerDetails,
        preNeedDetails,
        isAdminLogin,
        isProviderLogin,
        isPreNeedLogin,
      }, //  added preNeedDetails
    });
  },
});

/** Gate for USER-only routes */
function UserGate() {
  const details = getCurrentUserDetails("user");
  const isUserLoggedIn =
    !_.isEmpty(details) &&
    details.accessToken &&
    (!details.expiryTime || details.expiryTime > Date.now());

  if (!isUserLoggedIn) return <Navigate to={routes.LOGIN} replace />;
  return <Outlet />;
}

/** Optional: stop logged-in users from seeing login page */
function PublicOnlyGate() {
  const details = getCurrentUserDetails("user");
  const isUserLoggedIn =
    !_.isEmpty(details) &&
    details.accessToken &&
    (!details.expiryTime || details.expiryTime > Date.now());

  if (isUserLoggedIn) return <Navigate to={routes.HOME} replace />;
  return <Outlet />;
}

/** Redirect gate for /admin path */
function AdminRedirectGate() {
  const details = getCurrentUserDetails("superAdmin");
  const isAdminLoggedIn =
    !_.isEmpty(details) &&
    details.accessToken &&
    (!details.expiryTime || details.expiryTime > Date.now());

  if (isAdminLoggedIn) {
    return <Navigate to={routes.ADMIN_MANAGEMENT} replace />;
  }
  return <Navigate to={routes.ADMIN_LOGIN} replace />;
}


function App(props: AppProps) {
  const router = useMemo(() => {
    return createBrowserRouter(
      createRoutesFromElements(
        <Route element={<MainLayout />}>
          {/* ===================== PUBLIC ROUTES ===================== */}
          <Route path={routes.HOME} element={<HomePage />} />
          <Route path={routes.CONTACT_US} element={<ContactUsPageNew />} />
          <Route path={routes.BECOME_PROVIDER} element={<BecomeProvider />} />
          <Route
            path={routes.BECOME_PARTNER}
            element={<PartnerRegistrationForm />}
          />
          <Route path={routes.LISTING_PAGE} element={<ListingPage />} />
          <Route path={routes.DETAILS_PAGE} element={<DetailsPage />} />
          <Route path={routes.REVIEWS_PAGE} element={<ReviewsPage />} />
          <Route
            path={routes.PRENEED_PLANNERS_PAGE}
            element={<PreneedPlannersPage />}
          />
          <Route
            path={routes.PRENEED_PLANNERS_DETAILS_PAGE}
            element={<PreneedPlannersDetailsPage />}
          />
          <Route path={routes.SERVICES} element={<ServicesPage />} />
          <Route path={routes.TERMS_OF_SERVICE} element={<TermsOfServicePublic />} />
          <Route path={routes.AUTH_CALLBACK} element={<AuthCallback />} />

          {/* Public-only (example) */}
          <Route element={<PublicOnlyGate />}>
            <Route path={routes.LOGIN} element={<LoginPage />} />
          </Route>

          {/* ===================== USER PORTAL ===================== */}
          <Route element={<UserGate />}>
            <Route path={routes.CART_PAGE} element={<CartPage />} />
            <Route
              path={routes.ORDER_SUMMARY_PAGE}
              element={<OrderSummaryPage />}
            />
            <Route path={routes.PAYMENT_PAGE} element={<PaymentPage />} />
            <Route
              path={routes.PAYMENT_STATUS_PAGE}
              element={<PaymentStatusPage />}
            />
            <Route path={routes.USER_PROFILE} element={<UserProfilePage />} />
            <Route
              path={routes.ORDER_HISTORY_PAGE}
              element={<OrderHistoryPage />}
            />
            <Route
              path={routes.ORDER_DETAILS_PAGE}
              element={<OrderDetailsPage />}
            />
          </Route>

          {/* ===================== ADMIN PORTAL ===================== */}
          <Route path="/admin" element={<AdminRedirectGate />} />
          <Route path={routes.ADMIN_LOGIN} element={<AdminSection />} />

          <Route
            path={routes.ADMIN_MANAGEMENT}
            element={
              <ProtectedAdminRoute moduleName="Admin Management">
                <AdminSection />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.PROVIDER_MANAGEMENT}
            element={
              <ProtectedAdminRoute moduleName="Provider Management">
                <ProviderRequestLists />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.PROVIDER_REQUESTS}
            element={
              <ProtectedAdminRoute moduleName="Provider Requests">
                <ProviderRequestLists />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.PROVIDER_REQUEST_DETAILS}
            element={
              <ProtectedAdminRoute moduleName="Provider Requests">
                <ViewProviderRequestDetails />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.PROVIDER_PROFILES}
            element={
              <ProtectedAdminRoute moduleName="Provider Profiles">
                <ProviderProfilesList />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.PROVIDER_PROFILE_DETAILS}
            element={
              <ProtectedAdminRoute moduleName="Provider Profiles">
                <ViewProviderProfileDetails />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.PLANNER_MANAGEMENT}
            element={
              <ProtectedAdminRoute moduleName="Planner Management">
                <PlannerRequestsList />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.PLANNER_REQUESTS}
            element={
              <ProtectedAdminRoute moduleName="Planner Requests">
                <PlannerRequestsList />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.PLANNER_REQUEST_DETAILS}
            element={
              <ProtectedAdminRoute moduleName="Planner Requests">
                <ViewProviderRequestDetails />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.PLANNER_PROFILES}
            element={
              <ProtectedAdminRoute moduleName="Planner Profiles">
                <PlannerProfilesList />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.PLANNER_PROFILE_DETAILS}
            element={
              <ProtectedAdminRoute moduleName="Planner Profiles">
                <ViewProviderProfileDetails />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.SERVICE_LIST}
            element={
              <ProtectedAdminRoute moduleName="Service List">
                <ServiceList />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.ADMIN_TERMS_OF_SERVICE}
            element={
              <ProtectedAdminRoute moduleName="Terms Of Service">
                <TermsOfServicePage />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.ADMIN_PROFILE_MANAGEMENT}
            element={
              <ProtectedAdminRoute moduleName={MODULES.PROFILE_MANAGEMENT}>
                <ProfileManagement />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.ADMIN_USER_MANAGEMENT}
            element={
              <ProtectedAdminRoute moduleName={MODULES.USER_MANAGEMENT}>
                <UserManagement />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.ADMIN_BULK_UPLOAD_OPERATIONS}
            element={
              <ProtectedAdminRoute moduleName="Bulk Upload Operations">
                <BulkUploadOperations />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.ADMIN_COMMUNICATION_MANAGEMENT}
            element={
              <ProtectedAdminRoute
                moduleName={MODULES.COMMUNICATION_MANAGEMENT}
              >
                <CommunicationManagement />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.ADMIN_COMMUNICATION_TICKET_DETAILS}
            element={
              <ProtectedAdminRoute
                moduleName={MODULES.COMMUNICATION_MANAGEMENT}
              >
                <ViewTicketDetails />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.ADMIN_ORDER_MANAGEMENT}
            element={
              <ProtectedAdminRoute
                moduleName={MODULES.ORDER_MANAGEMENT}
              >
                <PaymentAndBilling />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path={routes.ADMIN_VIEW_ORDER}
            element={
              <ProtectedAdminRoute
                moduleName={MODULES.ORDER_MANAGEMENT}
              >
                <ViewOrder />
              </ProtectedAdminRoute>
            }
          />

          {/* ===================== PROVIDER PORTAL ===================== */}
          <Route path={routes.PROVIDER_LOGIN} element={<ProviderSection />} />
          <Route
            path={routes.PROVIDER_FORGOT_PWD}
            element={<ForgotPasswordPage />}
          />
          <Route
            path={routes.PROVIDER_RESET_PWD_EMAIL_LINK}
            element={<ResetPasswordPage />}
          />

          <Route
            path={routes.PROVIDER_DASHBOARD}
            element={
              <ProtectedProviderRoute moduleName="Provider Dashboard">
                <Dashboard />
              </ProtectedProviderRoute>
            }
          />
          <Route
            path={routes.PROVIDER_PROFILE_MGMT}
            element={
              <ProtectedProviderRoute moduleName="Provider Profile">
                <ProfileManagementTabs />
              </ProtectedProviderRoute>
            }
          />
          <Route
            path={routes.PROVIDER_PROFILE}
            element={
              <ProtectedProviderRoute moduleName="Provider Profile">
                <ProviderProfilePage />
              </ProtectedProviderRoute>
            }
          />
          <Route
            path={routes.PROVIDER_SERVICE_LIST}
            element={
              <ProtectedProviderRoute moduleName="Provider Profile">
                <ProviderServicesList />
              </ProtectedProviderRoute>
            }
          />
          <Route
            path={routes.BOOKING_AND_APPOINTMENT}
            element={
              <ProtectedProviderRoute moduleName="Provider Profile">
                <BookingRequests />
              </ProtectedProviderRoute>
            }
          />
          <Route
            path={routes.PROVIDER_LEADS}
            element={
              <ProtectedProviderRoute moduleName="Provider Profile">
                <Leads />
              </ProtectedProviderRoute>
            }
          />
          <Route
            path={routes.PROVIDER_LEAD_DETAILS}
            element={
              <ProtectedProviderRoute moduleName="Provider Profile">
                <ProviderLeadDetailsWrapper />
              </ProtectedProviderRoute>
            }
          />
          <Route
            path={routes.PAYMENTS_AND_BILLING}
            element={
              <ProtectedProviderRoute moduleName="Provider Profile">
                <PaymentsBilling />
              </ProtectedProviderRoute>
            }
          />
          <Route
            path={routes.PAYMENT_BILLING_VIEW}
            element={
              <ProtectedProviderRoute moduleName="Provider Profile">
                <ViewPaymentDetails />
              </ProtectedProviderRoute>
            }
          />
          <Route
            path={routes.PROVIDER_COMMUNICATION}
            element={
              <ProtectedProviderRoute moduleName="Provider Communication">
                <Communication />
              </ProtectedProviderRoute>
            }
          />
          <Route
            path={routes.PROVIDER_COMMUNICATION_TICKET_DETAILS}
            element={
              <ProtectedProviderRoute moduleName="Provider Communication">
                <ProviderViewTicketDetails />
              </ProtectedProviderRoute>
            }
          />

          <Route
            path={routes.PROVIDER_CONTRACT_MANAGEMENT}
            element={
              <ProtectedProviderRoute moduleName="Provider Profile">
                <ContractManagement
                  contractType={CONTRACT_MANAGEMENT_TYPE.PROVIDER}
                />
              </ProtectedProviderRoute>
            }
          />
          <Route
            path={routes.PROVIDER_TERMS_OF_SERVICE}
            element={
              <ProtectedProviderRoute moduleName="Terms Of Service">
                <TermsOfServicePage
                  viewOnly={true}
                  headerMode="provider"
                  variant="provider"
                />
              </ProtectedProviderRoute>
            }
          />

          {/* ===================== PRENEED PORTAL (NEW) ===================== */}
          <Route path={routes.PRENEED_LOGIN} element={<PreneedSection />} />
          {/* If you have forgot/reset pages for preneed, add them here */}
          <Route
            path={routes.PRENEED_FORGOT_PWD}
            element={<PreneedForgotPasswordPage />}
          />
          <Route
            path={routes.PRENEED_RESET_PWD_EMAIL_LINK}
            element={<PreneedResetPasswordPage />}
          />
          <Route
            path={routes.PRENEED_DASHBOARD}
            element={
              <ProtectedPreneedRoute moduleName="Preneed Dashboard">
                <PreneedDashboard />
              </ProtectedPreneedRoute>
            }
          />
          <Route
            path={routes.PRENEED_PROFILE_MGMT}
            element={
              <ProtectedPreneedRoute moduleName="Preneed Profile">
                <PreneedProfileManagementTabs />
              </ProtectedPreneedRoute>
            }
          />
          <Route
            path={routes.PRENEED_TERMS_OF_SERVICE}
            element={
              <ProtectedPreneedRoute moduleName="Terms Of Service">
                <TermsOfServicePage
                  viewOnly={true}
                  headerMode="provider"
                  variant="preneed-planner"
                />
              </ProtectedPreneedRoute>
            }
          />
          <Route
            path={routes.PRENEED_CONTRACT_MANAGEMENT}
            element={
              <ProtectedPreneedRoute moduleName="Preneed Contract Management">
                <ContractManagement
                  contractType={CONTRACT_MANAGEMENT_TYPE.PRENEED_PLANER}
                />
              </ProtectedPreneedRoute>
            }
          />
          <Route
            path={routes.PRENEED_PAYMENTS_AND_BILLING}
            element={
              <ProtectedPreneedRoute moduleName="Preneed Orders">
                <PreneedPaymentBillingList />
              </ProtectedPreneedRoute>
            }
          />
          <Route
            path={routes.PRENEED_PAYMENT_BILLING_VIEW}
            element={
              <ProtectedPreneedRoute moduleName="Preneed order view">
                <PreneedViewPaymentDetails />
              </ProtectedPreneedRoute>
            }
          />
          <Route
            path={routes.PRENEED_COMMUNICATION}
            element={
              <ProtectedPreneedRoute moduleName="Communication">
                <PreneedCommunication />
              </ProtectedPreneedRoute>
            }
          />
          <Route
            path={routes.PRENEED_COMMUNICATION_TICKET_DETAILS}
            element={
              <ProtectedPreneedRoute moduleName="Communication">
                <PreneedViewTicketDetails />
              </ProtectedPreneedRoute>
            }
          />
          <Route
            path={routes.PRENEED_PROFILE}
            element={
              <ProtectedPreneedRoute moduleName="Preneed Planner Profile">
                <PreneedProfilePage />
              </ProtectedPreneedRoute>
            }
          />

          <Route
            path={routes.PRENEED_SERVICE_PACKAGE}
            element={
              <ProtectedPreneedRoute moduleName="Preneed order view">
                <CreatePackage />
              </ProtectedPreneedRoute>
            }
          />
          <Route
            path={routes.PRENEED_BOOKING_AND_APPOINTMENT}
            element={
              <ProtectedPreneedRoute moduleName="Contract Orders">
                <PreneedBookingRequests />
              </ProtectedPreneedRoute>
            }
          />
          <Route
            path={routes.PRENEED_LEADS}
            element={
              <ProtectedPreneedRoute moduleName="Preneed Leads">
                <PreneedLeads />
              </ProtectedPreneedRoute>
            }
          />
          <Route
            path={routes.PRENEED_LEAD_DETAILS}
            element={
              <ProtectedPreneedRoute moduleName="Preneed Planner Profile">
                <PreneedLeadDetailsWrapper />
              </ProtectedPreneedRoute>
            }
          />
          {/* ===================== FALLBACK ===================== */}
          <Route path="*" element={<NotFound />} />
        </Route>,
      ),
    );
  }, []);

  return <RouterProvider router={router} />;
}

export default connect(
  mstp,
  mdtp,
)((props: AppProps) => {
  const { setLoggedIn } = props;
  const [loading, setLoading] = useState(true);

  const rehydrateSession = React.useCallback(() => {
    const isValidSession = (
      userType: "user" | "superAdmin" | "provider" | "preNeed",
    ) => {
      const details = getCurrentUserDetails(userType);
      if (!details?.accessToken) return false;
      if (details?.expiryTime && details.expiryTime <= Date.now()) return false;
      return true;
    };

    const path = window.location.pathname;

    const isUserPath =
      !path.startsWith("/admin") &&
      !path.startsWith("/provider") &&
      !path.startsWith("/preneed");
    const isAdminPath = path.startsWith("/admin");
    const isProviderPath = path.startsWith("/provider");
    const isPreNeedPath = path.startsWith("/preneed");

    const loggedIn = isUserPath && isValidSession("user");
    const adminLoggedIn = isAdminPath && isValidSession("superAdmin");
    const providerLoggedIn = isProviderPath && isValidSession("provider");
    const preNeedLoggedIn = isPreNeedPath && isValidSession("preNeed");

    const userDetails = loggedIn ? getCurrentUserDetails("user") : ({} as any);
    const superAdminDetails = adminLoggedIn
      ? getCurrentUserDetails("superAdmin")
      : ({} as any);
    const providerDetails = providerLoggedIn
      ? getCurrentUserDetails("provider")
      : ({} as any);
    const preNeedDetails = preNeedLoggedIn
      ? getCurrentUserDetails("preNeed")
      : ({} as any);

    setLoggedIn(
      loggedIn,
      userDetails,
      superAdminDetails,
      providerDetails,
      preNeedDetails,
      adminLoggedIn,
      providerLoggedIn,
      preNeedLoggedIn,
    );
  }, [setLoggedIn]);

  useEffect(() => {
    setLoading(true);
    rehydrateSession();
    setLoading(false);
  }, [rehydrateSession]);

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (
        e.key === "userDetails" ||
        e.key === "superAdminDetails" ||
        e.key === "providerDetails" ||
        e.key === "preNeedDetails"
      ) {
        rehydrateSession();
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [rehydrateSession]);

  const isPreproduction =
    (process.env.REACT_APP_ENV || process.env.NODE_ENV) === "preproduction";
  const isProduction =
    (process.env.REACT_APP_ENV || process.env.NODE_ENV) === "production";

  const isAdminPath = window.location.pathname.startsWith("/admin");

  if (isPreproduction && isProduction && !isAdminPath) {
    return <ComingSoon />;
  }

  return (
    <AppRoute>{loading ? <div>Loading...</div> : <App {...props} />}</AppRoute>
  );
});
